module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAkCAQAAABY3hDnAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBR0JCh1r86/HAAABgklEQVRIx+3Wz0oCURTH8d9Mgm0yjAqCoEWbFm6Clu5atAiC/lAUIUVP0CZbhBCBEEVBi54ooUUgWEJRUi+QWFnpIr4tdG6jplmNEOG5iwP3nvOBGWbOjNggj9eRJ2pRkF/eR9GCFrCSfOW8rguPxJAO3fCZTjyCC6Vkt+ZGtOF/AY/K8kgcKWfzfieZxkK/WhMkHE4VwyPFHPYP0UlO3ZQDv5mdcxa+iVtMcVY94Bx4ln3X+Eyz2CRuMUPS9BU4ZqkSDiP62OXJFF2yTEdD1GaelKl/5YhBRLgWFqKXOI+m+IoIvjroEmlT98wBA+WTOrAQPezwYJquWanCfUS4NOdP7NHvOm0ACxFkm5xpzrCGHyH8rHJj9h+J01fV+QUsRDcxsgZ5IEHCdSU5duj5pKsJWIgAW9zXfCyzxAjW6WgSFqKLKLcGvWOTQIPqb8ClNcw4YYa+rCvDvqaHS0aZPzU223Ab/gjnOR5Tp0diqJRa9htrq9gS98VWzPnx9DAK2n4H9NtAzWkAi4oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-mail.js
// module id = 180
// module chunks = 12


// WEBPACK FOOTER //
// ./src/images/icon-mail.js